import * as angular from 'angular';

import { DataType, ComponentDefinition } from '../../models';

class TagDataTypeSelectorController implements angular.IComponentController, angular.IOnChanges {
    static $inject = [];

    dataType: { name: string; value: DataType }[];
    isDisabled: boolean;
    disablePreviousStep: boolean;
    onChange: () => void;

    private _allEnum = [
        { name: DataType[DataType.Float], value: DataType.Float },
        { name: DataType[DataType.Digital], value: DataType.Digital },
        { name: DataType[DataType.PreviousStep], value: DataType.PreviousStep }
    ];

    $onInit() {
        this.buildEnum();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj['isDisabled']) {
            this.buildEnum();
        }
    }

    change() {
        if (this.onChange) {
            this.onChange();
        }
    }

    private buildEnum() {
        this.dataType = this.disablePreviousStep
            ? this._allEnum.filter(e => e.value !== DataType.PreviousStep)
            : this._allEnum;

        /* as if #26326 we need to be able to change type of digital set for calculated identifier
        this.dataType = (this.isDisabled)
            ? this._allEnum
            : this._allEnum.filter(e => e.value !== DataType.Digital);
        */
    }
}

export const wtTagDataTypeSelector: ComponentDefinition = {
    componentId: 'wtTagDataTypeSelector',
    controller: TagDataTypeSelectorController,
    controllerAs: 'vm',
    template: require('./tagDataTypeSelector.component.html'),
    bindings: {
        disablePreviousStep: '<?',
        formController: '<',
        isDisabled: '<?',
        model: '=',
        name: '@?',
        onChange: '&?'
    }
};